import React, { Component } from 'react';

export default class Logo extends Component {
    render() {
        const { classes } = this.props
        return (
            <div className={classes.divContainerInterno}>
                <div className={classes.divExterior}>
                    <div className={classes.divInterior}>
                        <img
                            src="../images/logo_cemig_saude.png"
                            alt="logo cemig saude"
                            className={classes.logo}
                            style={{ width: 100 }}
                        />
                    </div>
                </div>
            </div>
        )
    }
}
